import { render, staticRenderFns } from "./LocationForOrderStore.vue?vue&type=template&id=77bad416"
import script from "./LocationForOrderStore.vue?vue&type=script&lang=js"
export * from "./LocationForOrderStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports